module.exports = __webpack_public_path__ + "static/img_2498-4270c31faa509110ee2535f5135d52de.webp";